import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';


  
class ImageSnippet {
  constructor(public src: string, public file: File) {}
}

@Component({ 
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  modulos=[];
  constructor(public router: Router) { 
    
    try {            
      if(localStorage.getItem("id_role_usu")==null){
        //this.router.navigate(["/login"]);
        console.log("no usuario")
      }
    } catch (error) {
      this.router.navigate(["/login"]);
      console.log("error-login"+error)
    }
  }
  active:Number=0;
  cliente=localStorage.getItem("nom_cliente");
  usuario=localStorage.getItem("sufijo");
  
  bndmenu:boolean=true;
  bndmenuhk:boolean=true;
  modulos_menu(m){
    if(localStorage.getItem("garoce")=="1"){
      return true;
    }
    console.log(m)   
    if(this.modulos.length>0){
      switch (m) {
        case 'crm':
          for(var i=0;i<this.modulos.length;i++){
            if(Number(this.modulos[i])>=6 || Number(this.modulos[i])<=9){
              return true;
            }
          }
          break;
          case "administracion":
            for(var i=0;i<this.modulos.length;i++){
              if(Number(this.modulos[i])==11 || Number(this.modulos[i])==16){
                return true;
              }
            }
          break;
        default:
          break;
      }
    }
    return false;
  }
  _modulos="";
  modulos_active(c){
    
    if(localStorage.getItem("garoce")=="1"){
      return true;
    }
    if (this.router.url.indexOf('/cliente') > -1) {
      return true;
    }    
    if (this.router.url.indexOf('/nuevocliente') > -1) {
      return true;
    }
    if (this.router.url.indexOf('/lista_cliente') > -1) {
      return true;
    }
    if(c==0)return true;
    
    if(this.modulos.length>0){
      for(var i=0;i<this.modulos.length;i++){
        
        if(Number(c)==Number(this.modulos[i])){
          //console.log("menu"+c+"::"+this.modulos[i]+"ok")
          return true;
        }
      }
    }
    
    return false;
  }
  bnd_menu_desa=false;
  bnd_menu_chart=false;
  bnd_menu_crm=false;
  bnd_menu_adm=false;
  bnd_menu_capacitacion=false;
  
  bnd_role=false;
  bnd_estructura=false;
  bnd_persona=false;
  bnd_competencias=false;

  bnd_org=false;
  bnd_raci=false;
  bnd_servicios=false;
  bnd_tkt=false;
  bnd_hk=false;
  bnd_desp=false;

  bnd_cal=false;
  bnd_pro=false;
  bnd_celen=false;
  bnd_task=false;  
  
  bnd_usu=false;
  bnd_edtcli=false;
  
  bnd_capacit=false;
  
  despliega_menu(){
    this.bnd_menu_desa=false;
    this.bnd_menu_chart=false;
    this.bnd_menu_crm=false;
    this.bnd_menu_adm=false;
    this.bnd_menu_capacitacion=false;
    this.bnd_role=false;
      this.bnd_estructura=false;
      this.bnd_persona=false;
      this.bnd_competencias=false;    
      this.bnd_org=false;
      this.bnd_raci=false;
      this.bnd_servicios=false;
      this.bnd_tkt=false;
      this.bnd_hk=false;
      this.bnd_desp=false;    
      this.bnd_cal=false;
      this.bnd_pro=false;
      this.bnd_celen=false;
      this.bnd_task=false;      
      this.bnd_usu=false;
      this.bnd_edtcli=false;      
      this.bnd_capacit=false;
    if(localStorage.getItem("garoce")=="1"){
      this.bnd_menu_desa=true;
      this.bnd_menu_chart=true;
      this.bnd_menu_crm=true;
      this.bnd_menu_adm=true;
      this.bnd_menu_capacitacion=true;
      this.bnd_role=true;
      this.bnd_estructura=true;
      this.bnd_persona=true;
      this.bnd_competencias=true;    
      this.bnd_org=true;
      this.bnd_raci=true;
      this.bnd_servicios=true;
      this.bnd_tkt=true;
      this.bnd_hk=true;
      this.bnd_desp=true;    
      this.bnd_cal=true;
      this.bnd_pro=true;
      this.bnd_celen=true;
      this.bnd_task=true;      
      this.bnd_usu=true;
      this.bnd_edtcli=true;      
      this.bnd_capacit=true;
          
    }else{
    if(this.modulos.length>0){
      for(var i=0;i<this.modulos.length;i++){        
        switch (Number(this.modulos[i])) {
          case 1:this.bnd_raci=true;this.bnd_menu_chart=true;break;
          case 2:this.bnd_servicios=true;this.bnd_menu_chart=true;break;
          case 3:this.bnd_tkt=true;this.bnd_menu_chart=true;break;
          case 4:this.bnd_hk=true;this.bnd_menu_chart=true;break;
          case 5:this.bnd_desp=true;this.bnd_menu_chart=true;break;
          case 12:this.bnd_org=true;this.bnd_menu_chart=true;break;

          case 6:this.bnd_pro=true;this.bnd_menu_crm=true;break;
          case 7:this.bnd_cal=true;this.bnd_menu_crm=true;break;
          case 8:this.bnd_task=true;this.bnd_menu_crm=true;break;
          case 9:this.bnd_celen=true;this.bnd_menu_crm=true;break;
          
          case 10:this.bnd_capacit=true;this.bnd_menu_capacitacion=true;break;
          case 18:this.bnd_capacit=true;this.bnd_menu_capacitacion=true;break;
         
          case 17:this.bnd_competencias=true;this.bnd_menu_desa=true;break;
          case 13:this.bnd_estructura=true;this.bnd_menu_desa=true;break;
          case 14:this.bnd_persona=true;this.bnd_menu_desa=true;break;
          case 15:this.bnd_role=true;this.bnd_menu_desa=true;break;          
          
          case 11:this.bnd_usu=true;this.bnd_menu_adm=true;break;
          case 16:this.bnd_edtcli=true;this.bnd_menu_adm=true;break;    
        }
      }
      }
    }
   
  }
  ngOnInit() {
    this.modulos=localStorage.getItem("modulos").split(",")
    this.despliega_menu();
    
    if (this.router.url.indexOf('/cliente') > -1) {
      this.active = 1;
    }    
    if (this.router.url.indexOf('/nuevocliente') > -1) {
      this.active = 1;
    }
    if (this.router.url.indexOf('/lista_cliente') > -1) {
      this.active = 1;
    }
    
    

  }
  chart(){
    localStorage.setItem("menu_","1")
  }
  url:any="/org";
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }

}
